<template>
  <div class="wall-surface-area__table-wrap">
    <!-- header-row -->
    <!-- <div class="surface-area__table-header-row">
      <div class="table-headers">ORIENTATION</div>
      <div class="table-headers">WWR orientation-wise (Glass + Frame)		
</div>
      <div class="table-headers">Opening Area(sq M)</div>
    </div> -->
    <!-- data-rows -->
    <div class="window-type-rows-3B light-scrollbar scrollable">
      <div v-for="(window, i) in step3B.windowTypeArrObj" :key="i" class="window-type-columns-3B">
        {{ window.window_serial }}
        <v-select :items="step3B.window_types_data" item-text="type" item-value="openablePercent" dense outlined placeholder="Select" v-model="schema.inputs.step3B.windowTypeArrObj[i].window_type" return-object></v-select>
        <div v-for="(orient, k) in step3B.windowTypeArrObj[i].orientationObj" :key="k + 1">
          <!-- <template > -->
          <!-- <lv-input v-if="step3B.wwrWindowArrObj[k].windowOrientationWwr !== 0" bottomBar v-model="orient.inputOrientationPercent">
            <template #prepend>
              <div>
                {{ orient.orientation }}
              </div>
            </template>
          </lv-input> -->
          <v-text-field v-if="step3B.wwrWindowArrObj[k].windowOrientationWwr !== 0" outlined dense type="number" :prepend-icon="orient.orientation" v-model="orient.inputOrientationPercent" placeholder="Enter ">
            <!-- <template v-slot="prepend">
              {{ orient.orientation }}
            </template> -->
            <div slot="prepend">{{ orient.orientation }}</div>
          </v-text-field>
          <!-- </template> -->
        </div>
      </div>
      <!-- Input total must be 100% -->
      <!-- <div class="window-type-columns-3B">
      <div><lv-input label="Input must be 100%" /> </div>
      <div v-for="(orientationObj,l) in windowOrientations3B" :key="l+1" > 0 %</div>
      </div> -->
    </div>
    <hr />
    <div>
      <v-btn class="ma-2" outlined color="indigo" dense @click="addNewWindow">
        <v-icon left> mdi-plus </v-icon>
        New window
      </v-btn>
      <v-btn class="ma-2" outlined color="red" dense @click="removeWindow">
        <v-icon left> mdi-delete </v-icon>
        Remove window
      </v-btn>
      <v-alert v-if="showAlert" dense outlined type="error"> I'm a dense alert with the <strong>outlined</strong> prop and a <strong>type</strong> of error </v-alert>
    </div>
    <hr />
    <!-- <div class="step3B__window-type-note">Note: Summation of percentage input of individual direction of all windows together should add to 100% i.e. W1(N%) + W2(N%)..Wn(N%)=100%</div> -->
    <v-alert dense text border="left" color="teal" icon="mdi-alert-circle">
      *Note: Summation of percentage input of individual direction of all windows together should add to 100% i.e. W1(N%) + W2(N%)..Wn(N%)=100%
    </v-alert>
    <hr />
    <div class="step-3B__summary">
      <div class="summary-head">Summary:</div>
      <div class="summary-block__wrap">
        <div v-if="northWindowOrientation" class="summary-field__row" :class="{ '--invalid': totalNorthOrientation !== 100 && totalNorthOrientation !== 0 }">
          <div class="sumarry-field__label">Total window % in N:</div>
          <div class="summary-field__value">{{ northWindowOrientation }}%</div>
        </div>
        <div v-if="northEastWindowOrientation" class="summary-field__row" :class="{ '--invalid': totalNorthEastOrientation !== 100 }">
          <div class="sumarry-field__label">Total window % in NE:</div>
          <div class="summary-field__value">{{ northEastWindowOrientation }}%</div>
        </div>
        <div v-if="eastWindowOrientation" class="summary-field__row" :class="{ '--invalid': totalEastOrientation !== 100 }">
          <div class="sumarry-field__label">Total window % in E:</div>
          <div class="summary-field__value">{{ eastWindowOrientation }}%</div>
        </div>
        <div v-if="southEastWindowOrientation" class="summary-field__row" :class="{ '--invalid': totalSouthEastOrientation !== 100 }">
          <div class="sumarry-field__label">Total window % in SE:</div>
          <div class="summary-field__value">{{ southEastWindowOrientation }}%</div>
        </div>
        <div v-if="southWindowOrientation" class="summary-field__row" :class="{ '--invalid': totalSouthOrientation !== 100 }">
          <div class="sumarry-field__label">Total window % in S:</div>
          <div class="summary-field__value">{{ southWindowOrientation }}%</div>
        </div>
        <div v-if="southWestWindowOrientation" class="summary-field__row" :class="{ '--invalid': totalSouthWestOrientation !== 100 }">
          <div class="sumarry-field__label">Total window % in SW:</div>
          <div class="summary-field__value">{{ southWestWindowOrientation }}%</div>
        </div>
        <div v-if="westWindowOrientation" class="summary-field__row" :class="{ '--invalid': totalWestOrientation !== 100 }">
          <div class="sumarry-field__label">Total window % in W:</div>
          <div class="summary-field__value">{{ westWindowOrientation }}%</div>
        </div>
        <div v-if="northWestWindowOrientation" class="summary-field__row" :class="{ '--invalid': totalNorthWestOrientation !== 100 }">
          <div class="sumarry-field__label">Total window % in NW:</div>
          <div class="summary-field__value">{{ northWestWindowOrientation }}%</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LvInput from 'lightvue/input';
import LvDropdown from 'lightvue/dropdown';
export default {
  components: {
    LvInput,
    LvDropdown,
  },
  data() {
    return {
      // windowSerial3B: ["W1", "W2", "W3"],
      enableWWR: ['N', 'S'],
      showAlert: false,
      windowCount: 0,
      windowTypes3B: ['Openable Shutter', 'Fixed', 'Sliding-2 pane', 'Sliding-3 pane'],
      totalNorthOrientation: 0,
      totalNorthEastOrientation: 0,
      totalEastOrientation: 0,
      totalSouthEastOrientation: 0,
      totalSouthOrientation: 0,
      totalSouthWestOrientation: 0,
      totalWestOrientation: 0,
      totalNorthWestOrientation: 0,
    };
  },
  computed: {
    schema: {
      get: function() {
        return this.$store.state.schema;
      },
      set: function(newSchema) {
        this.$store.dispatch('setSchema', newSchema);
      },
    },
    step3B: {
      get: function() {
        return this.$store.state.schema.inputs.step3B;
      },
      set: function(step3B) {
        this.$store.dispatch('setStep3B', step3B);
      },
    },
    checkEnableWWR() {},
    northWindowOrientation() {
      this.totalNorthOrientation = 0;
      for (let i = 0; i <= this.step3B.windowTypeArrObj.length - 1; i++) {
        this.totalNorthOrientation = this.totalNorthOrientation + +this.step3B.windowTypeArrObj[i].orientationObj[0].inputOrientationPercent;
      }
      this.step3B.summary_window_type.total_n_orient = this.totalNorthOrientation;
      // console.log("Window return object",this.step3B.windowTypeArrObj[0].window_type);
      return this.totalNorthOrientation;
    },
    northEastWindowOrientation() {
      this.totalNorthEastOrientation = 0;
      for (let i = 0; i <= this.step3B.windowTypeArrObj.length - 1; i++) {
        this.totalNorthEastOrientation = this.totalNorthEastOrientation + +this.step3B.windowTypeArrObj[i].orientationObj[1].inputOrientationPercent;
      }
      this.step3B.summary_window_type.total_ne_orient = this.totalNorthEastOrientation;
      return this.totalNorthEastOrientation;
    },
    eastWindowOrientation() {
      this.totalEastOrientation = 0;
      for (let i = 0; i <= this.step3B.windowTypeArrObj.length - 1; i++) {
        this.totalEastOrientation = this.totalEastOrientation + +this.step3B.windowTypeArrObj[i].orientationObj[2].inputOrientationPercent;
      }
      this.step3B.summary_window_type.total_ne_orient = this.totalEastOrientation;
      return this.totalEastOrientation;
    },
    southEastWindowOrientation() {
      this.totalSouthEastOrientation = 0;
      for (let i = 0; i <= this.step3B.windowTypeArrObj.length - 1; i++) {
        this.totalSouthEastOrientation = this.totalSouthEastOrientation + +this.step3B.windowTypeArrObj[i].orientationObj[3].inputOrientationPercent;
      }
      this.step3B.summary_window_type.total_ne_orient = this.totalSouthEastOrientation;
      return this.totalSouthEastOrientation;
    },
    southWindowOrientation() {
      this.totalSouthOrientation = 0;
      for (let i = 0; i <= this.step3B.windowTypeArrObj.length - 1; i++) {
        this.totalSouthOrientation = this.totalSouthOrientation + +this.step3B.windowTypeArrObj[i].orientationObj[4].inputOrientationPercent;
      }
      this.step3B.summary_window_type.total_ne_orient = this.totalSouthOrientation;
      return this.totalSouthOrientation;
    },
    southWestWindowOrientation() {
      this.totalSouthWestOrientation = 0;
      for (let i = 0; i <= this.step3B.windowTypeArrObj.length - 1; i++) {
        this.totalSouthWestOrientation = this.totalSouthWestOrientation + +this.step3B.windowTypeArrObj[i].orientationObj[5].inputOrientationPercent;
      }
      this.step3B.summary_window_type.total_ne_orient = this.totalSouthWestOrientation;
      return this.totalSouthWestOrientation;
    },
    westWindowOrientation() {
      this.totalWestOrientation = 0;
      for (let i = 0; i <= this.step3B.windowTypeArrObj.length - 1; i++) {
        this.totalWestOrientation = this.totalWestOrientation + +this.step3B.windowTypeArrObj[i].orientationObj[6].inputOrientationPercent;
      }
      this.step3B.summary_window_type.total_ne_orient = this.totalWestOrientation;
      return this.totalWestOrientation;
    },
    northWestWindowOrientation() {
      this.totalNorthWestOrientation = 0;
      for (let i = 0; i <= this.step3B.windowTypeArrObj.length - 1; i++) {
        this.totalNorthWestOrientation = this.totalNorthWestOrientation + +this.step3B.windowTypeArrObj[i].orientationObj[7].inputOrientationPercent;
      }
      this.step3B.summary_window_type.total_ne_orient = this.totalNorthWestOrientation;
      return this.totalNorthWestOrientation;
    },
  },
  beforeUpdate() {
    this.calcOpenablePercent();
  },
  watch: {
    schema: {
      handler: function() {
        this.calcOpenablePercent();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    addNewWindow() {
      this.windowCount = this.step3B.windowTypeArrObj.length;
      let newWindow = {
        window_serial: `W${this.windowCount + 1}`,
        window_type: '',
        // window_openable_percent:0,
        input_glass_percent: 0,
        opaque_percent: 0,
        all_orient_openable_area: 0,
        all_orient_glass_area: 0,
        all_orient_opaque_area: 0,
        orientationObj: [
          {
            orientation: 'N',
            inputOrientationPercent: 0,
            calcOpenableArea: 0,
            calcGlassArea: 0,
            calcOpaqueArea: 0,
            orientFactor: 0.57,
            uValueNonOpaque: 0,
            selectedNonOpaqueMaterial: ``,
            abcNonOpaqueWindow: 0,
          },

          { orientation: 'NE', inputOrientationPercent: 0, calcOpenableArea: 0, calcGlassArea: 0, calcOpaqueArea: 0, orientFactor: 0.91, uValueNonOpaque: 0, selectedNonOpaqueMaterial: ``, abcNonOpaqueWindow: 0 },
          { orientation: 'E', inputOrientationPercent: 0, calcOpenableArea: 0, calcGlassArea: 0, calcOpaqueArea: 0, orientFactor: 1.16, uValueNonOpaque: 0, selectedNonOpaqueMaterial: ``, abcNonOpaqueWindow: 0 },
          { orientation: 'SE', inputOrientationPercent: 0, calcOpenableArea: 0, calcGlassArea: 0, calcOpaqueArea: 0, orientFactor: 1.13, uValueNonOpaque: 0, selectedNonOpaqueMaterial: ``, abcNonOpaqueWindow: 0 },
          { orientation: 'S', inputOrientationPercent: 0, calcOpenableArea: 0, calcGlassArea: 0, calcOpaqueArea: 0, orientFactor: 0.97, uValueNonOpaque: 0, selectedNonOpaqueMaterial: ``, abcNonOpaqueWindow: 0 },
          { orientation: 'SW', inputOrientationPercent: 0, calcOpenableArea: 0, calcGlassArea: 0, calcOpaqueArea: 0, orientFactor: 1.12, uValueNonOpaque: 0, selectedNonOpaqueMaterial: ``, abcNonOpaqueWindow: 0 },
          { orientation: 'W', inputOrientationPercent: 0, calcOpenableArea: 0, calcGlassArea: 0, calcOpaqueArea: 0, orientFactor: 1.16, uValueNonOpaque: 0, selectedNonOpaqueMaterial: ``, abcNonOpaqueWindow: 0 },
          { orientation: 'NW', inputOrientationPercent: 0, calcOpenableArea: 0, calcGlassArea: 0, calcOpaqueArea: 0, orientFactor: 0.91, uValueNonOpaque: 0, selectedNonOpaqueMaterial: ``, abcNonOpaqueWindow: 0 },
        ],
      };

      this.step3B.windowTypeArrObj.splice(this.windowCount, 0, newWindow);
    },
    calcOpenablePercent() {
      let totalOpenableArea = 0;
      for (let j = 0; j <= this.step3B.windowTypeArrObj.length - 1; j++) {
        let allOrientOpenableArea = 0;

        for (let k = 0; k <= this.step3B.wwrWindowArrObj.length - 1; k++) {
          // calculation of openable area for each orientation i.e [windowType.openablePercent*inputOreintPercent*openingArea of each orient]
          this.step3B.windowTypeArrObj[j].orientationObj[k].calcOpenableArea = +(this.step3B.windowTypeArrObj[j].window_type.openablePercent * 0.01 * this.step3B.windowTypeArrObj[j].orientationObj[k].inputOrientationPercent * 0.01 * this.step3B.wwrWindowArrObj[k].calcWindowOpeningArea).toFixed(2);
          if (this.step3B.windowTypeArrObj[j].orientationObj[k].checkedOpenableArea) {
            // console.log('checkbox value', this.step3B.windowTypeArrObj[j].orientationObj[k].checkedOpenableArea);

            //  calculation for sum of openable area of all orientations for each window
            allOrientOpenableArea = allOrientOpenableArea + +this.step3B.windowTypeArrObj[j].orientationObj[k].calcOpenableArea;
          }
        }
        this.step3B.windowTypeArrObj[j].all_orient_openable_area = +allOrientOpenableArea.toFixed(2);
        //  calculation for total openable area of all windows
        totalOpenableArea = totalOpenableArea + allOrientOpenableArea;
      }
      this.step3B.summary_window_openable.total_openable_area = totalOpenableArea.toFixed(2);
      // this.step3B.summary_window_openable.total_openable_area = this.step3B.windowTypeArrObj[j].all_orient_openable_area + this.step3B.summary_window_openable.total_openable_area;
    },
    removeWindow() {
      this.windowCount = this.step3B.windowTypeArrObj.length;
      if (this.windowCount !== 1) {
        this.step3B.windowTypeArrObj.splice(this.windowCount - 1, 1);
      } else {
        this.showAlert = !this.showAlert;
      }
    },
  },
};
</script>

<style lang="scss">
.surface-area__table-header-row {
  display: flex;
  width: 100%;
  background-color: #dedede;
  margin-top: 12px;
}
.scrollable {
  // height: 100%;
  overflow-x: auto;
  // overflow: auto; // here is the magic :)
}
.window-type-rows-3B {
  padding: 12px 4px 4px 4px;
  display: flex;
  flex-direction: row;
  // width: 100%;
  // overflow: auto;
  justify-content: space-around;
  .window-type-columns-3B {
    display: flex;
    flex-direction: column;
    // margin-right: 6px;
    padding: 8px;
    width: 120px;
    text-align: center;
    .lv-input__field {
      margin: 8px;
      text-align: end;
      .lv-input__prepend {
        width: 36px;
        background: #dedede;
        color: #fff;
        margin-right: 16px;

        div {
          padding: 8px;
        }
      }
    }
  }
}
.step3B__window-type-note {
  background-color: #b3f5db;

  font-style: italic;
  padding: 8px;
  margin: 12px 0px;
}
.step-3B__summary {
  margin-top: 10px;
  .summary-head {
    font-size: 18px;
    color: #343f4b;
    font-weight: 800;
  }
}
.summary-block__wrap {
  display: flex;
  flex-direction: column;
  .summary-field__row {
    display: flex;
    justify-content: space-between;
    margin: 4px 0px;
    border-radius: 4px;
    padding: 2px 4px;
    &.--invalid {
      background-color: rgb(250, 167, 167);
    }
  }
  .summary-field__label {
    font-size: 12px;
    color: #343f4b;
  }
}
</style>
